import { Controller } from '@hotwired/stimulus';
import { visit } from '@hotwired/turbo';

// Ligne de tableau cliquable : un clic hors des liens, boutons et champs
// ouvre le lien principal de la ligne (a[data-row-link] ; lien d'une
// fenêtre, data-turbo-frame : cliqué) ; ⌘, Ctrl, Maj ou clic du milieu :
// nouvel onglet ; une sélection de texte en cours n'ouvre rien.
export default class extends Controller {
    open(event) {
        if (event.type === 'auxclick' && event.button !== 1) return;
        if (event.target.closest('a, button, input, select, textarea, label, summary')) return;
        if (window.getSelection().toString() !== '') return;

        const link = event.target.closest('tr')?.querySelector('a[data-row-link]');
        if (!link) return;

        if (event.type === 'auxclick' || event.metaKey || event.ctrlKey || event.shiftKey) window.open(link.href, '_blank', 'noopener');
        else if (link.dataset.turboFrame) link.click();
        else visit(link.href);
    }
}
